import React from 'react'
import { Button, Table, Typography } from 'antd'
import { DeleteOutlined } from '@ant-design/icons'

import IntlMessages from '../../../util/IntlMessages'
import { StatusBadge } from '../../../design-system/StatusBadge/StatusBadge'
import { OPEN_API_LIMIT_REQUESTS_PER_MONTH } from '@vacationtracker/shared/data/app-parameters'
import { IAutomations } from '../../../types/custom-queries'

const { Paragraph, Text } = Typography

export interface LegacyApiKeysTableProps {
  keys: IAutomations[]
  canDelete: boolean
  deletingId: string | null
  onDelete: (row: IAutomations) => void
}

const LegacyApiKeysTable = ({ keys, canDelete, deletingId, onDelete }: LegacyApiKeysTableProps) => {
  if (keys.length === 0) {
    return null
  }

  const columns = [
    {
      title: <IntlMessages id="addons.openApi.apiKeyName" />,
      dataIndex: 'name',
      key: 'name',
      render: (name: string) => (
        <>
          {name}{' '}
          <StatusBadge tone="neutral">
            <IntlMessages id="publicApi.legacy.readOnlyTag" />
          </StatusBadge>
        </>
      ),
    },
    {
      title: <IntlMessages id="addons.openApi.currentMonthUsage" />,
      dataIndex: 'currentMonthUsage',
      key: 'currentMonthUsage',
      render: (currentMonthUsage: string) => {
        if (Number(currentMonthUsage) >= OPEN_API_LIMIT_REQUESTS_PER_MONTH) {
          return (
            <Text type="danger">
              ${OPEN_API_LIMIT_REQUESTS_PER_MONTH} / ${OPEN_API_LIMIT_REQUESTS_PER_MONTH}
            </Text>
          )
        } else {
          return `${currentMonthUsage} / ${OPEN_API_LIMIT_REQUESTS_PER_MONTH}`
        }
      },
    },
    {
      title: <IntlMessages id="addons.openApi.apiKeySecret" />,
      dataIndex: 'apiKeyValue',
      key: 'apiKeyValue',
      render: (apiKeyValue: string) => (apiKeyValue ? <Paragraph copyable={{ text: apiKeyValue }}>{apiKeyValue.slice(0, 4)}******</Paragraph> : '****'),
    },
    {
      title: '',
      className: 'action',
      width: 78,
      dataIndex: 'id',
      key: 'id',
      render: (id: string, row: IAutomations) => (
        <Button size="large" danger type="link" disabled={!canDelete} onClick={() => onDelete(row)} loading={Boolean(deletingId && deletingId === id)}>
          {!(deletingId && deletingId === id) && <DeleteOutlined />}
        </Button>
      ),
    },
  ]

  return (
    <div>
      <h2>
        <IntlMessages id="publicApi.legacy.title" />
      </h2>
      <p>
        <IntlMessages id="publicApi.legacy.description" />
      </p>
      <Table dataSource={keys} columns={columns} rowKey="id" pagination={false} />
    </div>
  )
}

export default LegacyApiKeysTable
